import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import DSButton, { BUTTON_TYPE } from '@elliemae/ds-button';
import { accordionActions } from './blocks.js';
import '@elliemae/ds-classnames';

var DSAccordionHeaderActions = function DSAccordionHeaderActions(_ref) {
  var customActions = _ref.customActions;
  if (!customActions) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(accordionActions)
  }, customActions.map(function (_ref2, key) {
    var _onClick = _ref2.onClick,
        rest = _objectWithoutProperties(_ref2, ["onClick"]);

    return /*#__PURE__*/React.createElement(DSButton, _extends({
      key: key,
      onClick: function onClick(e) {
        e.stopPropagation();
        if (_onClick) _onClick(e);
      }
    }, rest, {
      buttonType: BUTTON_TYPE.SECONDARY
    }));
  }));
};

export default DSAccordionHeaderActions;
//# sourceMappingURL=DSAccordionHeaderActions.js.map
